import React from 'react';
import { PortfolioSpeciesSourceProvider } from 'src/app/portfolio/state/portfolioSpeciesSource';
import PortfolioSummary from '../portfolio-summary/PortfolioSummary';

/**
 * The portfolio summary with its species cards read from the prediction grid.
 *
 * The same components as the live page, mounted inside a provider that changes where
 * the species cards' query points — see portfolioSpeciesSource. The habitat and
 * overview halves are unaffected; the grid holds neither.
 *
 */
const NextPortfolioSummary = () => (
    <PortfolioSpeciesSourceProvider source='grid'>
        <div className='flex flex-col gap-3' data-testid='next-portfolio-summary'>
            <PortfolioSummary />
        </div>
    </PortfolioSpeciesSourceProvider>
);

export default NextPortfolioSummary;
